import React from "react";

interface EmailCellProps {
    email: string;
}

export const EmailCell: React.FC<EmailCellProps> = ({ email }) => {
    return <span>{email}</span>;
};
